import { Fragment } from "react"
import Container from '../../../core/controls/components/container'
import Notice from '../../jsons/notice'


const NoticeContainer = (props) => {

    return (
        <Fragment>
            <Container {...Notice}  {...props} />
        </Fragment>
    )
}
export default NoticeContainer